import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import CompanyModel from "../../model/company.model";
import BrandModel from "../../model/brand.model";

@Injectable()
export default class BrandService {
    public constructor(private http: HttpClient) {
    }

    public show(id: number): Observable<BrandModel> {
        return this.http.get<BrandModel>(environment.apiUrl + '/brands/' + id);
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additional?: any): Observable<Pagination<CompanyModel>> {
        if(typeof query !== 'string') {
            query = '';
        }
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        let q = {query, page, limit, sorting};

        if(additional) {
            Object.assign(q, additional);
        }

        return this.http
            .get<Pagination<BrandModel>>(environment.apiUrl + '/brands?' + QueryEncoder.encodeURI(q));
    }

    public delete(brand: BrandModel): Observable<any> {
        return this.http.delete(environment.apiUrl + '/brands/' + brand.id).pipe(
            switchMap(_ => of(true)),
            catchError(_ => of(false))
        )
    }

    public update(brand: BrandModel): Observable<BrandModel> {
        return this.http.put<BrandModel>(environment.apiUrl + '/brands/' + brand.id, brand);
    }

    public create(brand: BrandModel): Observable<BrandModel> {
        return this.http.post<BrandModel>(environment.apiUrl + '/brands', brand);
    }
}
